import { render, staticRenderFns } from "./DeveloperDetail.vue?vue&type=template&id=2fc4e4b2&scoped=true&"
import script from "./DeveloperDetail.vue?vue&type=script&lang=js&"
export * from "./DeveloperDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperDetail.vue?vue&type=style&index=0&id=2fc4e4b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc4e4b2",
  null
  
)

export default component.exports